<template>
  <div>
    <el-form ref="form" :model="form" label-width="90px">
      <el-col :span="24">
        <el-form-item label="订单号：">
          <div class="div">{{form.orderNo}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="学生姓名：">
          <div class="div">{{form.user.realName}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话：">
          <div class="div">{{form.contactPhone}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所在学校：">
          <div class="div">{{form.user.schoolName}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="毕业年份：">
          <div class="div">{{form.user.graduateYear}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="专家姓名：">
          <div class="div">{{form.expertName}}</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="专家电话：">
          <div class="div">{{form.expert.contactPhone}}</div>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import {getShoppOrderInfo} from '@/api/serviceManagement.js'
export default {
  props: {
    orderId: {
      Type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        user:{},
        expert:{}
      },
      id: "",
    };
  },
  watch: {
    orderId: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.id = newValue;
        if(this.id){
          this.getShoppOrderInfo(this.id)
        }
      },
      deep: true,
    },
  },
  methods: {
    getShoppOrderInfo(id){
      getShoppOrderInfo({orderId: id}).then(res=>{
        console.log(res,'订单信息');
        this.form = res.data || {}
      })
    }
  },
};
</script>

<style lang="less" scoped>
.div{
  border: 1px solid #e5e5e5;
  width: 180px;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  border-radius: 5px;
  color: #606266;
  margin-top: 5px;
}
</style>